import styled from 'styled-components';

export const SpotsCounter = styled.div`
  font: 400 14px/24px ${({ theme }) => theme.fonts.join()};
  font-style: italic;
  color: ${({ theme }) => `${theme.colors.$alertRed}`};
  min-width: 70px;
`;
